import { Fragment, type ReactNode } from 'react';

/**
 * Fills a message's `{name}` placeholders with elements, such as a link or bold text, so each
 * language can put them where its word order needs them.
 */
export function rich(template: string, values: Readonly<Record<string, ReactNode>>): ReactNode {
  return template.split(/(\{\w+\})/).map((part, index) => {
    const name = /^\{(\w+)\}$/.exec(part)?.[1];
    return (
      <Fragment key={index}>{name !== undefined && name in values ? values[name] : part}</Fragment>
    );
  });
}
